import React from "react";

/**
 * Structured Data component for SEO rich snippets
 * Provides JSON-LD schema markup for better search engine understanding
 */
export const StructuredData: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ResearchProject",
    "name": "ACTT Study",
    "alternateName": "Aedes Control through Technology-driven Trapping",
    "description": "The ACTT study integrates cutting-edge mosquito collection traps, innovative new methods for assessing mosquito risk, and novel remote sensing and machine learning workflows to guide local vector operations and direct abatement efforts in a cost-efficient manner.",
    "url": "https://acttstudy.org",
    "logo": "https://acttstudy.org/logo.png",
    "sameAs": [
      "https://apps.apple.com/us/app/actt-study/id6744712322",
      "https://play.google.com/store/apps/details?id=org.acttstudy.actt"
    ],
    "applicationCategory": "HealthApplication",
    "operatingSystem": ["iOS", "Android"],
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "about": {
      "@type": "MedicalCondition",
      "name": "Mosquito-borne diseases"
    },
    "keywords": "mosquito surveillance, Aedes mosquito, vector control, mosquito-borne diseases, AI egg counting, public health research, mosquito trapping, disease prevention",
    "inLanguage": "en-US",
    "isAccessibleForFree": true
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default StructuredData;
